import type { CSSProperties } from 'react';
import JsonView from '@uiw/react-json-view';
import { darkTheme } from '@uiw/react-json-view/dark';

import { cn } from '@/lib/utils';

const panelDarkTheme = {
    ...darkTheme,
    '--w-rjv-background-color': '#020617',
    '--w-rjv-line-color': '#334155',
    '--w-rjv-color': '#7dd3fc',
    '--w-rjv-key-string': '#7dd3fc',
    '--w-rjv-arrow-color': '#bae6fd',
    '--w-rjv-edit-color': '#7dd3fc',
    '--w-rjv-info-color': '#94a3b8',
    '--w-rjv-update-color': '#fde047',
    '--w-rjv-copied-color': '#7dd3fc',
    '--w-rjv-curlybraces-color': '#a5f3fc',
    '--w-rjv-brackets-color': '#a5f3fc',
    '--w-rjv-type-string-color': '#fdba74',
    '--w-rjv-type-int-color': '#93c5fd',
    '--w-rjv-type-float-color': '#bef264',
    '--w-rjv-type-bigint-color': '#93c5fd',
    '--w-rjv-type-boolean-color': '#5eead4',
    '--w-rjv-type-date-color': '#cbd5e1',
    '--w-rjv-type-url-color': '#93c5ff',
    '--w-rjv-type-null-color': '#f472b6',
    '--w-rjv-type-nan-color': '#67e8f9',
    '--w-rjv-type-undefined-color': '#cbd5e1',
} as CSSProperties;

export interface JsonTreePanelProps {
    value: object;
    className?: string;
    /** Forwarded to JsonView: collapse depth / fully collapsed (see @uiw/react-json-view). */
    collapsed?: boolean | number;
    displayDataTypes?: boolean;
    displayObjectSize?: boolean;
    enableClipboard?: boolean;
}

export function JsonTreePanel({
    value,
    className,
    collapsed = false,
    displayDataTypes = false,
    displayObjectSize = true,
    enableClipboard = true,
}: JsonTreePanelProps) {
    return (
        <JsonView
            value={value}
            style={panelDarkTheme}
            className={cn('box-border min-h-full min-w-full py-4 pl-6 pr-4 text-[13px] leading-relaxed sm:pl-8 sm:pr-6', className)}
            collapsed={collapsed}
            displayDataTypes={displayDataTypes}
            displayObjectSize={displayObjectSize}
            enableClipboard={enableClipboard}
            indentWidth={18}
        />
    );
}
